/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSignal } from "solid-js";

import { DialogType } from "@/components/Dialogs/types";
import { useDialog } from "@/components/Dialogs/useDialog";
import { unique } from "@/lib/arrUtils";
import { isObjectEqual } from "@/lib/objectUtils";
import { renderFiatOrPlatCoinSymbol } from "@/lib/pointUtils";
import { renderInnerHtml } from "@/lib/utils";
import { activityStore } from "@/stores/activityStore";
import { sysConfigStore } from "@/stores/sysConfigStore";
import { userStore } from "@/stores/userStore";
import { PushMessage } from "@/stores/websocketStore";
import { ActivityTypeEnum } from "@/types/compontent/base/baseEnum";

import { useConfigRestrict } from "./useConfigRestrict";
import {
  VIP_ACT_LIST,
  useVipActivity,
  vipActivityObject,
} from "./useVipActivity";

// vip 升级弹窗
type VipUpgradeData = {
  newLv: number;
  oldLv: number;
};

// resConfig
const resConfig = {
  //vip 10 13 15等级权限开关
  activity: {
    //key 6001
    [ActivityTypeEnum.vipHost]: true,
    //key 6002
    [ActivityTypeEnum.vipExclusive]: true,
    //key 6003
    [ActivityTypeEnum.vipLuxury]: true,
  },
  //流水返利
  lossRebate: {
    event_start_day: 1, //活动持续时间周一1  周天7
    event_start_hour: 0, //活动持续开始时间小时
    event_start_minute: 0, //活动持续开始时间分
    event_start_second: 0, //活动持续开始时间秒
    event_end_day: 7, //活动持续结束时间日期 周一1  周天7
    event_end_hour: 23, //活动持续结束时间小时
    event_end_minute: 59, //活动持续结束时间分
    event_end_second: 59, //活动持续结束时间秒
  },
};

/* prettier-ignore */
const [vipUpgradeUpDiff, setVipUpgradeUpDiff] = createSignal<any[]>([]);
/* prettier-ignore */
const [vipUpgradeAddDiff, setVipUpgradeAddDiff] = createSignal<any[]>([]);

export const useVipUpgrade = () => {
  const { showDialog } = useDialog();
  const { getStatusByDeny, getStatusByLabelsDeny } = useConfigRestrict();

  const getActivityState = (aType: number): boolean => {
    if (
      userStore?.userInfo?.experience_status &&
      aType === ActivityTypeEnum.redpacket
    ) {
      return false;
    }
    const config = activityStore?.actConfigData?.[aType];

    if (config?.status) {
      const deny_pack = config?.deny_pack || [];
      const deny_pack_type = config?.deny_pack_type || 0;
      let result = getStatusByDeny(deny_pack, deny_pack_type, true);
      if (result) {
        const deny_label = config?.deny_labels || [];
        const deny_label_type = config?.deny_label_type || 0;
        result = getStatusByLabelsDeny(deny_label, deny_label_type);
      }

      return result;
    } else {
      return false;
    }
  };

  const getActivityByVip = (vip: number, isUpgradeMode = false) => {
    const levels = sysConfigStore.sysConfigData?.vip_config?.levels;
    const isVipMode2 = sysConfigStore.sysConfigData?.vip_config?.vip_mode === 2;

    const vipStoreGroupList: any[] = [];

    let svip = 1;
    let index = 1;
    const category: any = {};

    for (let i = 0; i < levels?.length; i++) {
      const el = levels[i];
      if (el.vip_type == 2) {
        el.svip = svip;
        svip++;
      }
      //分组使用vip_group
      if (isVipMode2) {
        if (!category[el.vip_category]) {
          el.vip_group = index;
          category[el.vip_category] = index;
          vipStoreGroupList[index - 1] = [];
          index++;
        } else {
          el.vip_group = category[el.vip_category];
        }
        vipStoreGroupList[el.vip_group - 1].push(el);
      }
    }

    const init = { ...vipActivityObject };

    let vipGroupList = null;
    let vipActive = null;
    let vipGroupIndex = 0;

    // 如果是 mode2
    if (isVipMode2 && !isUpgradeMode) {
      vipGroupIndex = vipStoreGroupList?.findIndex(
        (el: any) => el[0]?.vip <= vip && el[el.length - 1]?.vip >= vip,
      );
      vipGroupList = vipStoreGroupList?.[vipGroupIndex];
      vipActive = vipGroupList?.[vipGroupList.length - 1]?.vip;
    } else {
      vipActive = vip;
    }

    // 转盘活动
    // if (userStore.getActivityState(ActivityTypeEnum.roulette)) {
    //   const rouletteList = activityStore.roulette?.cfg?.list || [{ min_vip_limit: 16 }, { min_vip_limit: 16 }, { min_vip_limit: 16 }]

    //   //根据转盘配置等级及前端配置删除转盘
    //   if (vipActive >= rouletteList[2].min_vip_limit) {
    //     delete init[VipActivityEnum.vipRoulette2]
    //     delete init[VipActivityEnum.vipRoulette1]
    //   } else if (vipActive >= rouletteList[1].min_vip_limit) {
    //     delete init[VipActivityEnum.vipRoulette1]
    //     delete init[VipActivityEnum.vipRoulette3]
    //   } else if (vipActive < rouletteList[0].min_vip_limit) {
    //     delete init[VipActivityEnum.vipRoulette3]
    //     delete init[VipActivityEnum.vipRoulette2]
    //     delete init[VipActivityEnum.vipRoulette1]
    //   } else {
    //     delete init[VipActivityEnum.vipRoulette3]
    //     delete init[VipActivityEnum.vipRoulette2]
    //   }
    // } else {
    //   delete init[VipActivityEnum.vipRoulette3]
    //   delete init[VipActivityEnum.vipRoulette2]
    //   delete init[VipActivityEnum.vipRoulette1]
    // }

    const vipActivityObjList: any = {};

    for (let i = 0; i < VIP_ACT_LIST.length; i++) {
      const actType = VIP_ACT_LIST[i];

      if (!getActivityState(actType)) {
        delete init[actType];
        continue;
      }
      const reward = useVipActivity().getVipReward(actType, vipActive);

      if (reward) {
        vipActivityObjList[actType] = [reward];
      } else {
        delete init[actType];
      }
    }

    // 红包
    // const vipRedpacket = findVipRedpacket(vipActive);
    // if (getActivityState(ActivityTypeEnum.redpacket) || !vipRedpacket) {
    //   delete init[VipActivityEnum.vipRedpacket];
    // }

    // 高Vip功能开放等级
    const isUnOpenVipLuxury =
      isVipMode2 && !isUpgradeMode
        ? vipGroupIndex < vipStoreGroupList?.length - 1
        : vipActive <
          (vipActivityObject?.[ActivityTypeEnum.vipLuxury]?.vip ?? 1);
    if (!resConfig.activity[ActivityTypeEnum.vipLuxury] || isUnOpenVipLuxury) {
      delete init[ActivityTypeEnum.vipLuxury];
    }

    const isUnOpenVipExclusive =
      isVipMode2 && !isUpgradeMode
        ? vipGroupIndex < vipStoreGroupList?.length - 2
        : vipActive <
          (vipActivityObject?.[ActivityTypeEnum.vipExclusive]?.vip ?? 1);
    if (
      !resConfig.activity[ActivityTypeEnum.vipExclusive] ||
      isUnOpenVipExclusive
    ) {
      delete init[ActivityTypeEnum.vipExclusive];
    }

    const isUnOpenVipHost =
      isVipMode2 && !isUpgradeMode
        ? vipGroupIndex < vipStoreGroupList?.length - 3
        : vipActive < (vipActivityObject?.[ActivityTypeEnum.vipHost]?.vip ?? 1);
    if (!resConfig.activity[ActivityTypeEnum.vipHost] || isUnOpenVipHost) {
      delete init[ActivityTypeEnum.vipHost];
    }

    Object.keys(vipActivityObjList).forEach((key: any) => {
      const objList = vipActivityObjList[key];
      const notSame = objList?.findIndex(
        (el: any) => !isObjectEqual(el, objList[0]),
      );
      if (notSame < 0) {
        vipActivityObjList[key] = [objList[0]];
      }
    });

    const list = Object.values(init);

    list?.sort((a: any, b: any) => (a?.index > b?.index ? 1 : -1));
    // const textColor = useAppModal().value ? 'text-e-g-color-107 font-bold' : 'text-color-text-0 font-bold'
    const textColor = "text-color-text-0 font-bold"; //Todo Temp
    list?.forEach((el: any) => {
      const rewardList = vipActivityObjList?.[el?.key] || [];
      const currReward = rewardList?.[0];

      // if (el.key == ActivityTypeEnum.vipRedpacket) {
      // }
      if (el.key == ActivityTypeEnum.vipWeekly) {
        const vipWeekly = useVipActivity().findVipWeekly(vipActive);
        const vipWeeklyReward = vipWeekly?.reward as any;

        if (!el.params) el.params = {};
        el.params = {
          value1Ori: vipWeekly?.need_flow,
          value2Ori: vipWeeklyReward?.point,
          value1: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(vipWeekly?.need_flow),
            textColor,
          ),
          value2: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(vipWeeklyReward?.point),
            textColor,
          ),
          props: vipWeeklyReward?.props,
        };
      } else if (el.key == ActivityTypeEnum.vipMonthBonus) {
        const vipMonthBonus = useVipActivity().findVipMonthBonus(vipActive);
        const vipMonthBonusReward = vipMonthBonus?.reward as any;
        if (!el.params) el.params = {};
        el.params = {
          value1Ori: vipMonthBonus?.last_month_min_bet_point,
          value2Ori: vipMonthBonusReward?.point,
          value1: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(vipMonthBonus?.last_month_min_bet_point),
            textColor,
          ),
          value2: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(vipMonthBonusReward?.point),
            textColor,
          ),
        };
      } else if (el.key == ActivityTypeEnum.vipDayBonus) {
        const vipDayBonus = useVipActivity().findVipDayBonus(vipActive);
        const vipDayBonusReward = vipDayBonus?.reward as any;
        if (!el.params) el.params = {};
        el.params = {
          value1Ori: vipDayBonus?.min_flow,
          value2Ori: vipDayBonusReward?.point,
          value1: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(vipDayBonus?.min_flow),
            textColor,
          ),
          value2: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(vipDayBonusReward?.point),
            // textColor,
          ),
        };
      } else if (vipActivityObject?.[el.key as ActivityTypeEnum]?.type == 1) {
        if (!el.params) el.params = {};
        el.params = {
          valueOri: currReward,
          value: renderInnerHtml(
            renderFiatOrPlatCoinSymbol(currReward),
            // textColor,
          ),
        };
      } else {
        if (!el.params) el.params = {};
        el.params = {
          valueOri: currReward,
          value: renderInnerHtml(currReward + "%", textColor || ""),
        };
      }

      if (rewardList.length > 1) {
        el.tipList = [];
        const actRewardType =
          vipActivityObject?.[el.key as ActivityTypeEnum]?.type;
        for (let i = 0; i < rewardList?.length; i++) {
          if (actRewardType == 1) {
            el.tipList.push({
              vip: vipGroupList[i]?.vip,
              tipParams: renderFiatOrPlatCoinSymbol(rewardList?.[i]),
            });
          } else {
            el.tipList.push({
              vip: vipGroupList[i]?.vip,
              tipParams: rewardList?.[i] + "%",
            });
          }
        }
      } else {
        delete el.tipList;
      }
    });

    return list;
  };

  // 设置VIP升级数据
  const setVipUpgradeData = ({ newLv, oldLv }: VipUpgradeData) => {
    const oldVipList = getActivityByVip(oldLv, true);
    const newVipList = getActivityByVip(newLv, true);

    const upDiff = [];
    const addDiff = [];
    for (let i = 0; i < newVipList.length; i++) {
      // 过滤新增的活动
      const hasItem = oldVipList.find(
        (it: any) => it.title === newVipList[i].title,
      );
      if (!hasItem) {
        addDiff.push(newVipList[i]);
      }
      // 过滤升级的活动
      for (let j = 0; j < oldVipList.length; j++) {
        if (
          newVipList[i]?.params?.value1Ori > oldVipList[j]?.params?.value1Ori ||
          newVipList[i]?.params?.value2Ori > oldVipList[j]?.params?.value2Ori ||
          newVipList[i]?.params?.valueOri > oldVipList[j]?.params?.valueOri
        ) {
          upDiff.push(newVipList[i]);
        }
      }
    }

    const _upDiff = unique(upDiff);

    console.log("upDiff", _upDiff);
    console.log("addDiff", addDiff);

    setVipUpgradeUpDiff(_upDiff);
    setVipUpgradeAddDiff(addDiff);
  };

  const handleVipLevelUp = (item: PushMessage) => {
    if (item?.data === 1) return;

    const newVipLevel = Number(item?.data) || 0; // 新的 VIP等级
    const oldVipLevel = userStore.userInfo?.UserVip?.vip_level || 1; // 旧的VIP等级

    // 如果VIP等级大于旧等级，则显示VIP升级弹窗
    if (newVipLevel > oldVipLevel) {
      // 进行计算
      setVipUpgradeData({ newLv: newVipLevel, oldLv: oldVipLevel });
      setTimeout(() => {
        showDialog({
          type: DialogType.VipLevelUp,
          data: { level: newVipLevel },
        });
      }, 200);
    }
  };

  return {
    vipUpgradeUpDiff,
    vipUpgradeAddDiff,

    // 处理VIP升级
    handleVipLevelUp,
  };
};

/**
 * Todo 待测试内容
 *
 * 1. Vip 升级 功能
 * 2. 对应功能正常弹出
 */
